var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('resource',{attrs:{"resource":"user","original":_vm.user,"staticMode":_vm.isDeleted,"attributes":[
      {
        name: 'id',
        label: 'ID',
        disabled: true
      },
      {
        name: 'name',
        label: 'Name'
      },
      {
        name: 'email',
        label: 'Email'
      },
      {
        name: 'password',
        label: 'Password'
      },
      {
        name: 'roles',
        label: 'Rollen',
        type: 'RoleSelector'
      },
      {
        name: 'permissions',
        label: 'Berechtigungen',
        type: 'PermissionSelector'
      }
    ]},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h4',[_vm._v("\n        Systembenutzer Bearbeiten\n        "),(_vm.isDeleted)?_c('span',{staticClass:"badge badge-deleted ml-3"},[_vm._v("gelöscht")]):_vm._e(),_vm._v(" "),(_vm.isDeletion)?_c('span',{staticClass:"badge badge-deletion ml-3"},[_vm._v("in löschfrist")]):_vm._e(),_vm._v(" "),(_vm.isDisabled)?_c('span',{staticClass:"badge badge-disabled ml-3"},[_vm._v("gesperrt")]):_vm._e()]),_vm._v(" "),(_vm.isDeleted)?_c('p',[_vm._v("Gelöscht am: "+_vm._s(_vm.deleted_at))]):_vm._e(),_vm._v(" "),(_vm.isDeletion)?_c('p',[_vm._v("\n        Löschfrist seit: "+_vm._s(_vm.deletion_start_at)+"\n        "),_c('br'),_vm._v("\n        Bereits in Löschfrist: "+_vm._s(_vm.deletion_time)+"\n        "),_c('br'),_vm._v("\n        Löschfrist Ende: "+_vm._s(_vm.deletion_end_at)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.isDisabled)?_c('p',[_vm._v("\n        Gesperrt am: "+_vm._s(_vm.disabled_at)+"\n        "),_c('br'),_vm._v("\n        Grund: "+_vm._s(_vm.user.disabled_message)+"\n      ")]):_vm._e()]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }